export default __webpack_public_path__ + "static/media/answer.9c919588.svg";